import type { ConsentPurpose, ConsentState } from './contract'

export type ConsentModeValue = 'granted' | 'denied'
export interface GtmConsentSignal {
  version: 1
  modeEnabled: boolean
  required: boolean
  expiresAt: number | null
  states: {
    analytics_storage: ConsentModeValue
    ad_storage: ConsentModeValue
    ad_user_data: ConsentModeValue
    ad_personalization: ConsentModeValue
    personalization_storage: ConsentModeValue
    le_experimentation: ConsentModeValue
    le_unrestricted_scope: ConsentModeValue
    security_storage: ConsentModeValue
  }
}

export function createGtmConsentSignal(required: boolean, modeEnabled: boolean, state?: ConsentState): GtmConsentSignal {
  const accepted = state?.status === 'accepted' && state.expiresAt > Date.now()
  const value = (purpose: ConsentPurpose): ConsentModeValue =>
    !required || (accepted && state.purposes.includes(purpose)) ? 'granted' : 'denied'
  return {
    version: 1,
    modeEnabled,
    required,
    expiresAt: required ? state?.expiresAt ?? 0 : null,
    states: {
      analytics_storage: value('analytics'),
      ad_storage: value('advertising'),
      ad_user_data: value('advertising'),
      ad_personalization: value('advertising'),
      personalization_storage: value('personalisation'),
      le_experimentation: value('experimentation'),
      // A scope restriction, not a user-selectable purpose: consent cannot lift it.
      le_unrestricted_scope: required ? 'denied' : 'granted',
      security_storage: 'granted',
    },
  }
}
